module.exports = __webpack_public_path__ + "static/hero_bg-3750ddbe65a0aec0cab0efd5666e9165.jpg";